import './tours.css';

/**
 * Driver.js popover UI helpers: "NEW" chip and MUI-style close icon.
 * Styles for .tour-new-chip and .tour-close-btn live in tours.css.
 */

/** Class name for the "NEW" chip (styles in tours.css). */
export const TOUR_NEW_CHIP_CLASS = 'tour-new-chip';

/**
 * Injects a small success "NEW" chip above the popover title.
 * Call from onPopoverRender; pass the translated "new" label.
 */
export function renderNewChipAboveTitle(popover: { title: HTMLElement }, newLabel: string): void {
  const chip = document.createElement('span');
  chip.className = TOUR_NEW_CHIP_CLASS;
  chip.textContent = newLabel;
  popover.title.parentNode?.insertBefore(chip, popover.title);
}

/** MUI-style Close icon SVG (small, 18px). Replaces driver.js default × with an X icon. */
const MUI_CLOSE_ICON_SVG =
  '<svg class="tour-close-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="18" height="18"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>';

/**
 * Replaces the driver.js popover close button content with an MUI-style X icon.
 * Call from onPopoverRender.
 */
export function replaceCloseButtonWithMuiIcon(popover: { closeButton: HTMLButtonElement }): void {
  popover.closeButton.innerHTML = MUI_CLOSE_ICON_SVG;
  popover.closeButton.classList.add('tour-close-btn');
}
